/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// page
import Page from 'material/structure/page/page';
// structure
import Content from 'material/structure/content/content';
import EditEmbedName from 'pages/dashboard/embeds/management/editembedname/editembedname_container';
// material
// import Copy from 'material/copy/copy';
import Title from 'material/copy/title/title';
import ControlBar from 'material/embeds/controlbar/controlbar';
import EmbedCard from 'material/embeds/embedcard/embedcard';
import Icon from 'material/graphic/icon/icon';
// states
import EmptyState from 'material/states/empty/empty';
import LoadState from 'material/states/load/load';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/library/library_styles';



/* ========== ~~~~~~~~~~ PAGE : EMBEDS : LIBRARY : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class LibraryPage extends Component {
    constructor(props) {
        super(props);
        this.items = Object.assign([], this.props.clientEmbeds);
        this.typedText = '';
        this.content = [];
        this.status = [];
        this.state = {
            filteredItems: this.sortByNameAlphabetically(this.items), // set to clientEmbeds from BE initially (before search and sort)
            disableEmbedCards: false
        };
    }
    componentDidMount() {
        this.props.resetEmbedAndContentState()
    }
    componentDidUpdate(prevProps) {
        if (prevProps.clientEmbeds !== this.props.clientEmbeds) {
            this.items = Object.assign([], this.props.clientEmbeds);
            const filtered = this.sortByNameAlphabetically(this.items);
            this.setState({filteredItems: filtered});
        }
    }

    applyFilters = () => {
        // store existing filter types
        const types = { content: this.content.length > 0, status: this.status.length > 0, search: this.typedText.length > 0 };
        // filter items based on type that exists and value
        let filteredItems = this.items.filter(embed => {
            if (types.content && types.status) {
                return embed.liveContentTypes.some(liveContent => this.content.some(filter => filter === liveContent.toLowerCase())) && this.status.some(filter => filter === `${embed.active}`);
            } else if (types.content) {
                return embed.liveContentTypes.some(liveContent => this.content.some(filter => filter === liveContent.toLowerCase()));
            } else if (types.status) {
                return this.status.some(filter => filter === `${embed.active}`);
            } else {
                return this.items;
            }
        });
        // now search what was filtered
        if (types.search) filteredItems = filteredItems.filter(embed => embed.embedName.toLowerCase().includes(this.typedText.toLowerCase()) || this.props.clientSites[embed.siteUUID].toLowerCase().includes(this.typedText.toLowerCase()));
        // render filter items
        this.setState({ filteredItems: filteredItems });
    };
    handleSearch = (typedText) => {
        this.typedText = typedText;
        this.applyFilters();
    };

    sortByNameAlphabetically = (embeds) => {
        return embeds.sort(function(a, b) {
            var textA = a.embedName.toUpperCase();
            var textB = b.embedName.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });
    };
    editEmbed = (embedUUID) => {
        this.props.editEmbed(embedUUID);
        if(!this.state.disableEmbedCards) this.setState({ disableEmbedCards: true })
    };
    viewAnalytics = (embedUUID) => {
        this.props.viewAnalytics(embedUUID);
        if(!this.state.disableEmbedCards) this.setState({ disableEmbedCards: true })
    };
    deleteEmbed = (embedUUID) => {
        this.props.displayModal(false);
        this.props.deleteEmbed(embedUUID, this.props.accountUUID, this.resetDisableEmbedCards);
        if(!this.state.disableEmbedCards) this.setState({ disableEmbedCards: true })
    };
    resetDisableEmbedCards = () => {
        this.setState({ disableEmbedCards: false });
    };
    _renderEmbeds() {
        // this is pulling from local state now, so we can update local state with a thinned list of embeds based on search or sort
        return this.state.filteredItems.map(embed => <EmbedCard key={embed.embedUUID}
                                                               embedUUID={embed.embedUUID}
                                                               status={embed.active}
                                                               name={embed.embedName}
                                                               mocked={this.props.mocked}
                                                               site={this.props.clientSites[embed.siteUUID]}
                                                               posterImage={embed.posterImage}
                                                               activeContents={embed.liveContentTypes}
                                                               editPermitted={this.props.editPermitted}
                                                               editEmbed={this.editEmbed}
                                                               viewAnalytics={this.viewAnalytics}
                                                               deleteEmbed={this.deleteEmbed}
                                                               disableEmbedCards={this.state.disableEmbedCards} />);
    }
    _renderCreateEmbedCard() {
        return (<div className={`newembed disabled-${this.state.disableEmbedCards || !this.props.isDataReceived}`} onClick={this.createNewEmbed}>
                                                       <Icon name={`plus-circle`} />
                                                       <div className={`text`}>Create a new Embed!</div>
                                                   </div>)
    }
    createNewEmbed = () => {
        this.props.displayModal(true, <EditEmbedName createEmbed={true} updateEmbed={false} />)
    };
    _renderLoadScreen = () => (<Content>
                                    <LoadState
                                        graphicName={`embed`}
                                        graphicText={`Sample Embed Question`}
                                        bodycopy={`We're fetching your Embeds.`}
                                    />
                                </Content>);
    _renderEmptyState = () => (<Content>
                                    <EmptyState
                                        graphicName={`paintbrush`}
                                        graphicText={`Paint Brush and Canvas`}
                                        bodycopy={this.props.editPermitted ? <span>Create your first embed and start driving <strong>increased engagement</strong> with your visitors!</span> :
                                            <span>No Embeds have been created for your account yet.</span>}
                                        buttonName={this.props.editPermitted ? `letsstart` : null}
                                        buttonText={this.props.editPermitted ? `Let's Start` : null}
                                        buttonClick={this.props.editPermitted ? this.createNewEmbed : null}
                                    />
                                </Content>);
    handleSelectType = (types) => {
        this.content = types;
        this.applyFilters();
    };
    handleSelectStatus = (status) => {
        this.status = status;
        this.applyFilters();
    };
    render() {
        return(
            <Page name={`library`} klass={this.props.classes.library}>
                {!this.props.isDataReceived ? this._renderLoadScreen() :
                    !this.items.length ? this._renderEmptyState() :
                    <Content>
                        <div className={`libraryelement library-controls`}>
                            <ControlBar
                                searchDefaultValue={this.typedText}
                                searchPlaceholder={`Search by Name or URL`}
                                searchOnChange={this.handleSearch}
                                handleSelectType={this.handleSelectType}
                                handleSelectStatus={this.handleSelectStatus}
                            />
                        </div>
                        <div className={`libraryelement library-content`}>
                            <Title size={`small`} name={`numberof`}>
                                <h3>
                                    <span className={`total`}>Total Embeds ({this.items.length})</span>
                                    {this.items.length === this.state.filteredItems.length ? null :
                                        <span className={`filtered`}>Sorted Embeds ({this.state.filteredItems.length})</span>
                                    }
                                </h3>
                            </Title>
                            <div className={`embeds`}>
                                {this.props.editPermitted ? this._renderCreateEmbedCard() : null}
                                {this._renderEmbeds()}
                            </div>
                        </div>
                    </Content>
                }
            </Page>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(LibraryPage);
